import { useEffect, useRef, useState } from 'react'
import { connect } from 'react-redux'

import MobileHeader from '../Common/Header/MobileHeader'
import useCheckMobileScreen from '../../common/hooks/use-check-mobile-screen-hook'
import {
  PERMISSION_SCREEN,
  INVENTORY_DETAIL_FIELDS,
} from '../../common/constant/page-constant'
import {
  HEADER_CONFIG,
} from '../../common/constant/common-constant'
import SearchIcon from '../../assets/SearchIcon'
import {
  getPharmacyInventoryHelper,
  updatePharmacyInventoryItemHelper,
} from '../../helper/settings-helper'
import './ManagePharmacyInventory.scss'
import Alert from '../../components/Alert/Alert'
import { updateInventoryItemAlertAction } from '../../modules/actions/action'
import ManagePharmacyInventoryForm from './ManagePharmacyInventoryForm'
import usePagination from '../../common/hooks/usePagination'
import Pagination from '../../components/Pagination/Pagination'
import Loader from '../../components/Loader/Loader'

const ManagePharmacyInventory = (props) => {
  const isMobile = useCheckMobileScreen()
  const invoiceInputRef = useRef()
  const pharmacyInputRef = useRef()
  const pagination = usePagination({
    initialPage: 1,
    initialLimit: 50,
  })

  const [headerOptions] = useState({
    [HEADER_CONFIG.IS_BACK_VISIBLE]: true,
    [HEADER_CONFIG.TITLE]: 'Pharmacy Inventory',
    [HEADER_CONFIG.HANDLE_BACK_FUNC]: () => props?.onBackClick(),
  })
  const [inventoryData, setInventoryData] = useState([])
  const [permissions, setPermissions] = useState({})
  const [open, setOpen] = useState(false)
  const [updateAlert, setUpdateAlert] = useState(false)
  const [serverError, setServerError] = useState(undefined)
  const [loading, setLoading] = useState(false)
  const [editItemData, setEditItemData] = useState({})

  const [filterInvoiceNo, setFilterInvoiceNo] = useState('')
  const [filterPharmacyName, setFilterPharmacyName] = useState('')

  useEffect(() => {
    let updateInventoryItemAlert = props.alert?.updateInventoryItemAlert
    setUpdateAlert(updateInventoryItemAlert)
  }, [props.alert?.updateInventoryItemAlert])

  useEffect(() => {
    if (props.loginData.permissions) {
      let permission = props.loginData.permissions.filter(
        (permission) => permission.screen === PERMISSION_SCREEN.SETTINGS
      )[0]

      if (permission) setPermissions(permission)
    }
  }, [props.loginData])

  useEffect(() => {
    getInventoryData()
  }, [pagination.page, pagination.limit])

  const getInventoryData = async () => {
    setInventoryData([])
    setLoading(true)

    const params = { ...pagination.getQueryParams() }
    const filterData = {}
    if (filterInvoiceNo) filterData.invoice_number = filterInvoiceNo
    if (filterPharmacyName) filterData.pharmacy_name = filterPharmacyName

    getPharmacyInventoryHelper(filterData, params)
      .then((res) => {
        let { data, count } = res
        if (count !== undefined && count !== null) {
          pagination.setTotalItems(count)
        }
        setLoading(false)
        setInventoryData(data || [])
      })
      .catch((err) => {
        console.log('err: ', err)
        setLoading(false)
      })
  }

  const handleFilterSearch = () => {
    pagination.goToPage(1)
    getInventoryData()
  }

  const formatDateForInput = (dateStr) => {
    if (!dateStr) return ''
    const d = new Date(dateStr)
    if (isNaN(d.getTime())) return dateStr
    return d.toISOString().split('T')[0]
  }

  const handleRowClick = (item) => {
    setEditItemData({
      id: item.id,
      product_receiving_id: item.product_receiving_id,
      product_name: item.product_name,
      invoice_number: item.invoice_number,
      pharmacy_name: item.pharmacy_name,
      [INVENTORY_DETAIL_FIELDS.BATCH_NUMBER]: item.batch_number || '',
      [INVENTORY_DETAIL_FIELDS.EXPIRY_DATE]: formatDateForInput(item.expiry_date),
      [INVENTORY_DETAIL_FIELDS.QUANTITY]: item.quantity || '',
      [INVENTORY_DETAIL_FIELDS.BONUS_QUANTITY]: item.bonus_quantity || '',
      [INVENTORY_DETAIL_FIELDS.TOTAL_PRICE]: item.total_price || '',
      [INVENTORY_DETAIL_FIELDS.RATE_PER_UNIT]: item.rate_per_unit || '',
    })
    setOpen(true)
  }

  const handleItemDetailsUpdate = (key, value) => {
    setServerError(undefined)
    setEditItemData((prev) => ({ ...prev, [key]: value }))
  }

  const handleSubmit = async () => {
    setServerError(undefined)

    const data = {
      id: editItemData.id,
      product_receiving_id: editItemData.product_receiving_id,
      batch_number: editItemData[INVENTORY_DETAIL_FIELDS.BATCH_NUMBER],
      expiry_date: editItemData[INVENTORY_DETAIL_FIELDS.EXPIRY_DATE],
      quantity: editItemData[INVENTORY_DETAIL_FIELDS.QUANTITY],
      bonus_quantity: editItemData[INVENTORY_DETAIL_FIELDS.BONUS_QUANTITY],
      total_price: editItemData[INVENTORY_DETAIL_FIELDS.TOTAL_PRICE],
      rate_per_unit: editItemData[INVENTORY_DETAIL_FIELDS.RATE_PER_UNIT],
    }

    updatePharmacyInventoryItemHelper(data)
      .then(() => {
        props.updateInventoryItemAlertAction(true)
        setTimeout(() => {
          props.updateInventoryItemAlertAction(false)
        }, 5000)
        getInventoryData()
        resetDrawerData()
        handleDrawerToggle()
      })
      .catch((err) => {
        setServerError(err)
      })
  }

  const handleDrawerToggle = () => {
    if (open) {
      resetDrawerData()
    }
    setOpen(!open)
  }

  const resetDrawerData = () => {
    setEditItemData({})
  }

  return (
    <>
      {isMobile && <MobileHeader headerOptions={headerOptions} />}
      {updateAlert && (
        <Alert
          success
          alertType="success"
          alertMessage="Inventory item updated Successfully!"
          onClose={() => props.updateInventoryItemAlertAction(false)}
        />
      )}
      <div className="pageBodyRightPanel">
        {!isMobile && (
          <div className="pageBodyRightPanelHeader dFlex jcSpaceBetween aiCenter mb-5">
            <div className="pageBodyRightPanelHeading">
              Manage Pharmacy Inventory
            </div>
            <div className="addProductBtn dFlex aiCenter">
              <div className="formGroup mb-0 searchBar expand inventorySearchBar">
                <input
                  ref={invoiceInputRef}
                  type="text"
                  className="formControl"
                  placeholder="Invoice No"
                  value={filterInvoiceNo}
                  onChange={(e) => setFilterInvoiceNo(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleFilterSearch()}
                />
                <div className="searchIcon">
                  <SearchIcon />
                </div>
              </div>
              <div className="formGroup mb-0 searchBar expand inventorySearchBar ml-4">
                <input
                  ref={pharmacyInputRef}
                  type="text"
                  className="formControl"
                  placeholder="Pharmacy Name"
                  value={filterPharmacyName}
                  onChange={(e) => setFilterPharmacyName(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleFilterSearch()}
                />
                <div className="searchIcon">
                  <SearchIcon />
                </div>
              </div>
              <button
                className="btn btnPrimary ml-4"
                onClick={handleFilterSearch}
              >
                SEARCH
              </button>
            </div>
          </div>
        )}

        <div className="productLlistWrap">
          {inventoryData && (
            <div className="tabContent mb-4">
              <div className="tableScrollWrap">
                <table className="table productTable inventoryTable">
                  <thead>
                    <tr>
                      <th>Invoice No</th>
                      <th>Pharmacy Name</th>
                      <th>Product Name</th>
                      <th>Batch No</th>
                      <th>Expiry Date</th>
                      <th>Qty</th>
                      <th>Bonus Qty</th>
                      <th>Total Price</th>
                      <th>Rate/Unit</th>
                    </tr>
                  </thead>
                  <tbody>
                    {inventoryData?.map((item) => (
                      <tr
                        key={item?.id}
                        className="clickableRow"
                        onClick={() => handleRowClick(item)}
                      >
                        <td>{item.invoice_number}</td>
                        <td>{item.pharmacy_name}</td>
                        <td>{item.product_name}</td>
                        <td>{item.batch_number}</td>
                        <td>{formatDateForInput(item.expiry_date)}</td>
                        <td>{item.quantity}</td>
                        <td>{item.bonus_quantity}</td>
                        <td>{item.total_price}</td>
                        <td>{item.rate_per_unit}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}
          {loading ? (
            <Loader />
          ) : (
            <Pagination
              currentPage={pagination.page}
              totalPages={pagination.totalPages}
              onPageChange={pagination.goToPage}
              onPrevPage={pagination.prevPage}
              onNextPage={pagination.nextPage}
              onFirstPage={pagination.firstPage}
              onLastPage={pagination.lastPage}
              hasNextPage={pagination.hasNextPage}
              hasPrevPage={pagination.hasPrevPage}
              showFirstLast={true}
              maxPageButtons={5}
            />
          )}
        </div>
        <ManagePharmacyInventoryForm
          handleDrawerToggle={handleDrawerToggle}
          open={open}
          serverError={serverError}
          editItemData={editItemData}
          handleItemDetailsUpdate={handleItemDetailsUpdate}
          handleSubmit={handleSubmit}
        />
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    alert: state.alertReducer.alert,
    loginData: state.loginDataReducer?.loginData,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateInventoryItemAlertAction: (payload) =>
      dispatch(updateInventoryItemAlertAction(payload)),
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManagePharmacyInventory)
